import InputNumber from 'antd/es/input-number';
import CreateAntField from './CreateAntField';

export default CreateAntField(InputNumber);
